<template v-if="chartData">
  <div :id="`${chartData.name}ChartWrapper`" class="chart__wrapper">
    <h6 class="chart__title">{{ chartData.title }}</h6>
    <span class="chart__subtitle">{{ chartData.subtitle }}</span>
    <div class="chart__canvas_wrapper">
      <canvas :id="chartData.name"></canvas>
    </div>
  </div>
</template>

<script>
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  Tooltip,
  Legend,
  BarController,
  BarElement,
} from 'chart.js'

Chart.register(
  Tooltip,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  Legend,
  BarController,
  BarElement,
)

var isDollarSignNeeded = false

export default {
  name: 'ProgramMonthBarChart',
  props: {
    barChartData: {
      type: Object,
      default: () => {}
    },
    chartData: {
      type: Object,
      default: () => {
        return {
          name: "ProgramMonth",
          title: "Program Month",
          subtitle: "Distribution of users by program month.",
          data: {
            labels: ["Month 1", "Month 2", "Month 3", "Month 4", "Month 5", "Month 6", "Month 7", "Month 8", "Month 9", "Month 10", "Month 11", "Month 12"],
            datasets: [{
              data: [{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},],
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 205, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(201, 203, 207, 0.2)'
              ],
              borderColor: [
                'rgb(255, 99, 132)',
                'rgb(255, 159, 64)',
                'rgb(255, 205, 86)',
                'rgb(75, 192, 192)',
                'rgb(54, 162, 235)',
                'rgb(153, 102, 255)',
                'rgb(201, 203, 207)'
              ],
              borderWidth: 1,
              label: "Year 1",
            }]
          }
        }
      }
    },
    charts: {
      type: Array,
      default: () => [],
    },
    isDollarSignNeeded: {
      type: Boolean,
    },
  },
  data() {
    return {
      config: {
        type: 'bar',
        data: {},
        options: {
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: 1
              }
            }
          }
        }
      }
    }
  },
  updated() {
    this.createBarChart()
  },
  mounted() {
    this.createBarChart()
  },
  methods: {
    createBarChart() {
      const defaultBarChartData = {
        labels: ["Month 1", "Month 2", "Month 3", "Month 4", "Month 5", "Month 6", "Month 7", "Month 8", "Month 9", "Month 10", "Month 11", "Month 12"],
        datasets: [
          {
            data: [{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},],
            backgroundColor: [ '#1D5A5F'],
            borderColor: [ '#1D5A5F'],
            borderWidth: 1,
            label: "Year 1"
          },
          {
            data: [{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},{count: 0},],
            backgroundColor: ['#FEDA67'],
            borderColor: ['#FEDA67'],
            borderWidth: 1,
            label: "Year 2",
          }
        ]
      }

      // Map the data
      for(let i = 0; i < 24; i++) {
        let datasetIndex = i < 12 ? 0 : 1
        let dataIndex = i < 12 ? i : i - 12
        defaultBarChartData.datasets[datasetIndex].data[dataIndex] = this.barChartData[i] ? this.barChartData[i]["count"] : 0
      }

      const ctx = document.getElementById(this.chartData.name)

      this.config.data = defaultBarChartData

      var chart = new Chart(ctx, this.config)

      const chartWrapper = document.getElementById(`${this.chartData.name}ChartWrapper`)

    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';

.chart {
  &__wrapper {
    border: 1px solid $soft-gray;
    display: inline-block;
    width: 100%;
    padding: 1em;
  }

  &__subtitle {
    font-style: italic;
  }

  &__title {
    margin-bottom: 0;
    color: $black;
  }

  &__canvas_wrapper {
    position: relative;
  }
}
</style>
